var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"overlay",on:{"click":_vm.hide}},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }